import { startSearch } from '../actions/publicActions';
import getScenarioStore from '../selectors/getScenarioStore';
import { ActionSource } from 'owa-analytics-actions';
import { mutator } from 'satcheljs';

export default mutator(startSearch, actionMessage => {
    getScenarioStore(
        actionMessage.scenarioId
    ).queryActionSource = actionMessage.actionSource as ActionSource;
});
